function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.25 2H14.3705C13.756 2 13.178 2.23925 12.7445 2.6735L2.67376 12.744C1.77276 13.6458 1.77651 15.099 2.67376 15.9963L9.00401 22.3265C9.90076 23.2232 11.359 23.2227 12.2553 22.3265L22.326 12.2557C22.7605 11.8215 23 11.244 23 10.6298V2.75C23 2.33575 22.6645 2 22.25 2ZM21.5 10.6298C21.5 10.8433 21.4165 11.044 21.2655 11.1952L11.1948 21.266C10.8835 21.577 10.3773 21.5785 10.0645 21.266L3.73426 14.9353C3.42276 14.6252 3.42051 14.1178 3.73426 13.8048L13.8058 3.7335C13.956 3.58325 14.1568 3.5 14.3705 3.5H21.5V10.6298Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.75 9.5C18.9907 9.5 20 8.49075 20 7.25C20 6.00925 18.9907 5 17.75 5C16.5093 5 15.5 6.00925 15.5 7.25C15.5 8.49075 16.5093 9.5 17.75 9.5ZM17.75 6.5C18.1637 6.5 18.5 6.8365 18.5 7.25C18.5 7.6635 18.1637 8 17.75 8C17.3363 8 17 7.6635 17 7.25C17 6.8365 17.3363 6.5 17.75 6.5Z",
  fill: "currentColor"
});

var SvgBrands = function SvgBrands(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrands, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/brands.0c3ae5b6.svg";
export { ForwardRef as ReactComponent };